import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
// import otheraxios from 'axios';

// Import Styles
import '@/assets/styles/styles.scss';
// Import Bootstrap-Vue
import BootstrapVue from 'bootstrap-vue';
// Import FontAwesome
import './assets/fontawesome.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import Axios
import axios from '@/assets/ts/axios';
import VueAxios from 'vue-axios';

// Vue.prototype.$http = axios
Vue.use(VueAxios, axios);

// Register BootstrapVue components
Vue.use(BootstrapVue);

// Register FontAwesome
library.add(fas);
library.add(far);
Vue.component('fa', FontAwesomeIcon);


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY');
  }
});

// const genericapiinstance = otheraxios.create({
//   baseURL: process.env.VUE_APP_RAM_GENERIC_API_URL,
// })
// genericapiinstance.defaults.headers.post['Content-Type'] = 'application/json';
// genericapiinstance.interceptors.response.use((response: any) => {
//   return response;
// }, (error: any) => {
//   if (typeof error.response !== 'undefined' && error.response.status === 401) {
//       store.commit('auth/setToken', '');
//       store.commit('auth/setUsername', '');
//       store.commit('auth/setName', '');
//       store.commit('auth/setRole', '');

//       axios.defaults.headers.common.Authorization = '';

//       router.push({
//           name: 'Login',
//           params: {
//               error: 'Your session has expired. Please login.',
//           },
//       });
//   }

//   throw error;
// });
// export default genericapiinstance;
// Register FontAwesome
// Vue.component('fa', FontAwesomeIcon);
// Vue.use(VueLodash,lodash);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
